<template>
  <div class="row">
    <div class="col-xs-12">
      <h3>
        <slot name="title"></slot>
      </h3>
      <div class="small">
        <slot name="subtitle"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeading',
};
</script>

<style scoped>
.small {
  font-size: 18px;
  color: rgb(119, 119, 119);
  font-weight: 400;
  text-transform: uppercase;
  margin-top: 0px;
  margin-bottom: 10px;
}
</style>
